import _isNil from 'lodash/isNil';
import React, { ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import CircularLoading from '@Components/CircularLoading/CircularLoading';
import { ColumnWidth } from '@Components/InspectEntityComponents/EntityDrawerAttributeRow';
import { renderPoleBasics } from '@Components/InspectEntityComponents/EntityDrawerUtils';
import { selectedAnalysisEntityState } from '@Data/qualityControl/Reducer';
import LayoutStyles from '@Views/QualityControl/InProgressView.scss';
import Styles from './EntityDetails.scss';

export const EntityDetails = () => {
    const selectedAnalysisEntity = useSelector(selectedAnalysisEntityState);

    const ikeOfficeData = useMemo(() => {
        if (
            !selectedAnalysisEntity?.hasBaseData ||
            _isNil(selectedAnalysisEntity?.generic_data[0]?.fields)
        )
            return null;

        return renderPoleBasics(
            selectedAnalysisEntity,
            null,
            ColumnWidth.SMALL
        );
    }, [selectedAnalysisEntity]);

    const innerHtml = _isNil(ikeOfficeData) ? (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <CircularLoading />
        </div>
    ) : (
        ikeOfficeData.map((d) => {
            if (!_isNil(d)) {
                const element = d as ReactElement;
                const key = d.key ?? crypto.randomUUID();
                return React.cloneElement(element, { key: key });
            }
        })
    );

    return (
        <div className={LayoutStyles.entitydetailsContainer}>
            <div className={Styles.titleRow}>
                {selectedAnalysisEntity?.client_id}
            </div>
            {innerHtml}
        </div>
    );
};
